export enum EAnalyticsEvents {
  CLICK_SIDEBAR_HOME = 'click_sidebar_home',
  CLICK_SIDEBAR_MY_TICKETS = 'click_sidebar_my_tickets',
  CLICK_SIDEBAR_GLOBAL_POLICIES = 'click_sidebar_global_policies',
  CLICK_SIDEBAR_GLOBAL_TRAININGS = 'click_sidebar_global_trainings',
  CLICK_SIDEBAR_HELP_LINE = 'click_sidebar_help_line',
  CLICK_SIDEBAR_ROLE_SETTINGS = 'click_sidebar_role_settings',
  CLICK_NEXT_CREATE_TICKET = 'click_next_create_ticket',
  CLICK_PREVIOUS_CREATE_TICKET = 'click_previous_create_ticket',
  CLICK_SUBMIT_CREATE_TICKET = 'click_submit_create_ticket',
  CLICK_TICKET_DETAILS = 'click_ticket_details',
  CLICK_TAB_TICKET_DETAILS = 'click_tab_ticket_details',
  CLICK_FILTER_DATE_MY_TICKETS = 'click_filter_date_my_tickets',
  CLICK_FILTER_TYPE_MY_TICKETS = 'click_filter_type_my_tickets',
  CLICK_FILTER_STATUS_MY_TICKETS = 'click_filter_status_my_tickets',
  CLICK_FILTER_ZONE_MY_TICKETS = 'click_filter_zone_my_tickets',
  CLICK_FILTER_BU_MY_TICKETS = 'click_filter_bu_my_tickets',
  CLICK_SEARCH_MY_TICKETS = 'click_search_my_tickets',
}
